'use strict';

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:loginWidget
 * @description
 * # loginWidget
 */
angular.module('gfcmsApp')
  .directive('loginWidget', function($interval, dateFilter, $http, $location,
    cfpLoadingBar, appSettings, AuthenticationService, FlashService) {
    return {
      templateUrl: '/views/login2.html',
      restrict: 'EA',
      scope: {},
      link: function link(scope) {

        var baseUrl = appSettings.api.baseUrl;

        scope.login = login;
        scope.loginData = {
          userName: '',
          password: ''
        };

        function login() {
          cfpLoadingBar.start();
          scope.dataLoading = true;
          AuthenticationService.Login(scope.loginData).then(function(response) {
            scope.loggedIn = true;
            scope.dataLoading = false;
            cfpLoadingBar.complete();
            $location.path('/');
          }, function(err) {
            //FlashService.Error(err.error_description, false);
            scope.dataLoading = false;
            cfpLoadingBar.complete();
          });
        }
      }
    };
  });
